<mat-dialog-content xmlns="http://www.w3.org/1999/html">
  <h2>
    {{ data.title }}
    <mat-divider></mat-divider>
  </h2>
  <mat-card-content>
    <div [innerHTML]="data.text" class="dialog-text"></div>
    <div class="align-right">
      <button mat-button mat-dialog-close>Ok</button>
    </div>
  </mat-card-content>
</mat-dialog-content>

